import styled from 'styled-components';
import materialUI from '../../../material-UI';
import color from '../../../constants/color';

// ->
export const ContainerForm = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
export const CardForm = styled(materialUI.Card)`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  width: 80%;
  margin-bottom: 10px;

  @media only screen and (max-width: 748px) {
    flex-direction: column;
    width: 95%;
  }
`;
export const CardFormBody = styled.div`
  display: flex;
  background-color: ${(props) => props.color};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  min-height: 493px;


  @media only screen and (max-width: 748px) {
    width: 100%;
  }
  div {
    font-family: Inter;
  }
`;
export const Item = styled.div`
  display: flex;
  height: 52px;
  width: 100%;
  background-color: ${color.white};
  border-radius: 16px;
  align-items: center;
  margin: 0px 0px 8px 0px;

  div {
    color: ${color.VivazBlack};
    font-family: Inter;
    font-size: 0.95em;
  }
  @media only screen and (max-width: 733px) {
    div {
      font-family: Inter;
      margin-right: 8px;
      font-size: 0.90em;
      color: ${color.VivazBlack};
    }
    height: 56px;
  }
`;
export const Number = styled.div`
  div {
    margin: 0px 27px 0px 27px;
    color: ${color.greenButton}
  }
`;
export const MarginLeft = styled.div`
  padding: 0px 48px 0px 48px;
`;
export const Img = styled.img``;
export const Button = styled(materialUI.Button)`
  border-radius: 18px;
  color: ${color.white};
  height: 32px;
  width: 129px;
  background-color: ${color.primary};
  font-size: 10px;
  font-weight: normal;
`;
export const Title = styled.div`
  font-size: 24px;
  color: ${color.Black}
  font-family: Inter;
`;
export const Info = styled.div`
  font-size: 14px;
  color: ${color.Black}
  margin: 18px 0px 18px 0px;
  font-family: Inter;
  text-align: center;
`;
export const FooterBotton = styled.div`
  display: flex;
  width: 100%;
  margin-right: 58px;
  margin-top: 52px;
  justify-content: end;  
`;
export const RowSelect = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowFormSelect = styled.div`
  display: flex;
  flex-direction: row;
  width: 40%;
  margin-top: 16px;
  align-items: center;
  cursor: pointer;


  div {
    font-size: 12px;
    font-family: Inter;
    margin-left: 16px;
    color: ${color.VivazBlack};
  }
`;
export const SizedBox = styled.div`
  height: 24px;
`;
export const SizedBoxMultple = styled.div`
  height: 70px;
`;
export const Space = styled.div`
  height: 18px;
`;
export const PaddingContainer = styled.div`
  display: flex;
  padding: 0px 60px 0px 60px;
`;
export const TextButton = styled.div`
  color: ${color.primary};
  font-family: Inter;
  font-size: 10px;
  cursor: pointer;
`;
export const ContainerInfoImage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;
export const ContainerInfoImageHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 27px 0px 0px 27px;
`;

export const PageNumber = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 32px;
  align-items: center;
  background-color: ${color.Secondary};
  color: ${color.white};
  font-size: 12px;
  margin-right: 15px;
  height: 32px;
  width: 32px;
`;
export const RowInputs = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;
export const OnPress = styled(materialUI.IconButton)`
  height: 32px;
  width: 32px;
`;
export const LoadingSize = styled(materialUI.CircularProgress)`
  color: white
`;
